// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IContextualMenuProps } from "@fluentui/react";
import type { IComponentAs } from "@fluentui/react/lib/Utilities";

import type { MenuDefinition } from "./MenuDefinition";

/**
 * We send this for helping us generate the full menu definition and finally full menu props
 * when menus are connected to the store. This does not include MenuSection or MenuItemControlProps
 * which would need query the store. That information will gotten directly by talking to the store
 * when the menu is actually open - pay for play.
 *
 * NOTE: I would have liked this interface to be very small or even to not exist at all.
 * But, with the current structure of code this is needed.
 */
interface BaseDeferredMenuDefinition {
  parentKeytipSequence?: string[];

  /**
   * If we pass in a deferred menu definition, we would also need to pass this prop in
   * which will be responsible for generating the full menu props and actually rendering the menu.
   */
  menuAs: IComponentAs<IContextualMenuProps>;

  /**
   * If this is true, the menu will open automatically when the menu is rendered.
   * This is useful for menus that we want to trigger a programatic open for.
   */
  shouldAutoOpen?: boolean;
}

/**
 * This is the deferred Menu Definition for normal controls
 */
export interface DeferredNormalMenuDefinition
  extends BaseDeferredMenuDefinition {
  /**
   * This is the model id that will search for in the Redux store to get out menu model.
   * This refers to the menu's "anchor" control - like flyout anchors, split buttons, preview galleries etc.
   */
  anchorId: string;
  type: "DeferredNormalMenuDefinition";
}

/**
 * This is the deferred menu definition for overflow menus, which do not have an anchor.
 */
// export interface DeferredOverflowMenuDefinition extends BaseDeferredMenuDefinition {
//   overflowMenuDefinition?: MenuDefinitionUnion;
//   type: 'DeferredOverflowMenuDefinition';
// }

/**
 * This is the deferred menu definition for overflow menus, which do not have an anchor.
 */
export interface DeferredOverflowMenuDefinition
  extends BaseDeferredMenuDefinition {
  overflowMenuDefinition?: MenuDefinition;
  anchorId?: string;
  type: "DeferredOverflowMenuDefinition";
}

export type DeferredMenuDefinition =
  | DeferredNormalMenuDefinition
  | DeferredOverflowMenuDefinition;

/**
 * When we defer menu props generation to when the menu is actually opened, we need to send a dummy empty menu
 * props object to Fabric. Otherwise, Fabric will not even mount the menu.
 */
export const emptyMenuProps: IContextualMenuProps = {
  items: [],
};
